import React from "react";
import { Link } from "react-router-dom";
import { Carousel } from "react-bootstrap";
import { FaArrowAltCircleLeft, FaArrowAltCircleRight } from "react-icons/fa";
// style
import styles from "./../../pages/home/home.module.css";
// images
import "./banner.css";

const MainCarousel = () => {
  const HomImgs = [
    {
      id: 1,
      src: "https://res.cloudinary.com/dxmdlrz9t/image/upload/v1750100535/01-home_yossj0.png",
      content: "Safe & Secure Home Security",
      desc: "Premium Security Devices",
      color: "#ffff",
      alt: "Professional home security installation in Nakuru Kenya",
    },
    {
      id: 2,
      src: "https://res.cloudinary.com/dxmdlrz9t/image/upload/v1750099649/carousel-1_mkbefb.jpg",
      content: "Best CCTV & Security Solutions",
      desc: "Why Choose Our Security Systems?",
      color: "#fff",
      alt: "CCTV installation services near Nakuru",
    },
    {
      id: 3,
      src: "https://res.cloudinary.com/dxmdlrz9t/image/upload/v1750099650/carousel-3_laevyn.jpg",
      content: "Innovative Security Solutions",
      desc: "Reliable Protection Guaranteed",
      color: "#fff",
      alt: "Business security systems in Nakuru Rift Valley",
    },
  ];

  return (
    <div
      className="banner"
      role="region"
      aria-label="Security Solutions Carousel"
      itemScope
      itemType="https://schema.org/ItemList"
    >
      <div className="container">
        <div className="slider-container">
          <Carousel
            fade
            className={styles["carousel-indicators"]}
            prevIcon={
              <FaArrowAltCircleLeft
                className={styles.carouselControl}
                aria-label="Previous slide"
              />
            }
            nextIcon={
              <FaArrowAltCircleRight
                className={styles.carouselControl}
                aria-label="Next slide"
              />
            }
          >
            {HomImgs.map((img) => (
              <Carousel.Item
                key={img.id}
                className={`${styles["carousel-item"]}`}
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
              >
                <meta itemProp="position" content={img.id} />
                <img
                  className={`d-block w-100 h-100 ${styles.carouselImage}`}
                  src={img.src}
                  alt={img.alt}
                  itemProp="image"
                />
                <Carousel.Caption className={`${styles["carousel-caption"]}`}>
                  <div className={`${styles.captionCarouel}`}>
                    <div className="row">
                      <p
                        className={`col-5 col-md-3 col-lg-2 ${styles.discount}`}
                        itemProp="description"
                      >
                        {img.desc}
                      </p>
                    </div>
                    <div className="row">
                      <h1
                        className="col-10 col-md-6 col-xl-8 mt-2"
                        style={{
                          color: `${img.color}`,
                          fontFamily: `Poetsen One`,
                          fontSize: "30px",
                        }}
                        itemProp="name"
                      >
                        {img.content}
                      </h1>
                    </div>
                    <Link
                      to="/shop"
                      className="banner-btn"
                      aria-label="Shop security products in Nakuru"
                      itemProp="url"
                    >
                      Shop now
                    </Link>
                  </div>
                </Carousel.Caption>
              </Carousel.Item>
            ))}
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default MainCarousel;
